export default [{
  path: '/users',
  name: 'users',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/users/index')
}]
